import cardDetailsComponent from './cardDetails.component';

let cardDetailsModule = angular.module('vacations-absences.cardDetails', [])

.component('cardDetails', cardDetailsComponent)

.name;

export default cardDetailsModule;



// WEBPACK FOOTER //
// ./client/app/components/cardDetails/cardDetails.js